exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".support-tab{-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.enjoying-Google-Driv{text-align:left;width:240px;line-height:1.29;color:#2b5672;font-size:14px}.div-link{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.div-link .btn-upgrade-link{color:#3899ec !important;border-radius:0px !important;padding:0 10px}.links{padding:24px}.review{padding-left:24px;padding-top:15px;padding-right:24px;text-align:center;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.review .btn-confirm-primary{padding:0 24px;margin:17px 0 24px 0 !important}button:focus{outline:none !important}button.control-button.btn-upgrade-link{white-space:initial;overflow:visible;text-align:left}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/settings/Containers/gdUnitControlPanel/modules/support/support.scss
// module id = 447
// module chunks = 0 1